import { JsonObject, JsonProperty } from 'json2typescript';

import { AdvisoryModel, ClientRelation, ContractLiteInterface, ContractStatus } from '../../../core';
import { AdvisoryModelAdapter } from '../../client/helpers/serializer/adapters/advisory-model.adapter';
import { ContractStatusAdapter } from '../../client/helpers/serializer/adapters/contract-status.adapter';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { ClientRelationAdapter } from '../../client/helpers/serializer/adapters/client-relation.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('ContractLite')
export class ContractLite implements ContractLiteInterface {
    @JsonProperty('PortfolioCode', IdAdapter, true)
    private _code: Id = undefined;

    @JsonProperty('Code', IdAdapter, true)
    private _encryptedCode: Id = undefined;

    @JsonProperty('AdvisoryModel', AdvisoryModelAdapter, true)
    private _advisoryModel: AdvisoryModel = undefined;

    @JsonProperty('Status', ContractStatusAdapter, true)
    private _status: ContractStatus = undefined;

    @JsonProperty('Contract_relation', String, true)
    private _contract_relation: String = undefined;


    get code(): Id {
        return this._code;
    }

    get encryptedCode(): Id {
        return this._encryptedCode;
    }

    get advisoryModel(): AdvisoryModel {
        return this._advisoryModel;
    }

    get status(): ContractStatus {
        return this._status;
    }

    get contract_relation(): String {
        return this._contract_relation;
    }

    isAdvisoryModelSuitabilityOrGDC(): boolean {
        return (
            this._advisoryModel === AdvisoryModel.A || this._advisoryModel === AdvisoryModel.P || this._advisoryModel === AdvisoryModel.G
        );
    }

    isAdvisoryModelSuitability(): boolean {
        return this._advisoryModel === AdvisoryModel.A || this._advisoryModel === AdvisoryModel.P;
    }

    isAdvisoryModelGDC(): boolean {
        return this._advisoryModel === AdvisoryModel.G;
    }
}
